import { Link as RouterLink } from '@tanstack/react-router';
import React, { ReactElement, ReactNode } from 'react';

interface WorkbenchLinkProps {
  href: string;
  children: ReactNode;
}

function WorkbenchLink({ href, children }: WorkbenchLinkProps): ReactElement {
  return (
    <RouterLink to={href} style={{ textDecoration: 'underline' }}>
      {children}
    </RouterLink>
  );
}

export default WorkbenchLink;
